import axios from 'axios'
import * as http from 'http' //引用axios
import Vue from 'vue'

const httpAgent = new http.Agent({ keepAlive: false })
// create an axios instance
const service = axios.create({
  // baseURL: config.isCDN ? 'http://content.json.rr.tv': 'http://alpha-web-api.rr.tv',
  // baseURL: process.env.BASE_URL || '/dev-api',
  baseURL: 'https://moblie-api.fqdy.pro',
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  },
  httpAgent: httpAgent,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
})
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    console.log('url:', config.url)
    if (process.server && config.headers && !config.headers['http_forwarded_ip']) {
      config.headers['http_forwarded_ip'] = global['x-forwarded-for'] || 'none'
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data
    if (res.code === '00000') {
      // console.log('接口响应：', res)
      return res
    } else {
      //console.error('接口调用出错res：', res)
      return Promise.reject(new Error(res.msg || 'Error'))
    }
  },
  (error) => {
    //console.error('接口调用出错：', error) // for debug
    return Promise.reject(error)
  }
)
export default service
